export const VALID_AWS_SSM_REGIONS = [
  "us-east-2",
  "us-east-1",
  "us-west-1",
  "us-west-2",
  "af-south-1",
  "ap-east-1",
  "ap-south-2",
  "ap-southeast-3",
  "ap-southeast-4",
  "ap-south-1",
  "ap-northeast-3",
  "ap-northeast-2",
  "ap-southeast-1",
  "ap-southeast-2",
  "ap-northeast-1",
  "ca-central-1",
  "ca-west-1",
  "eu-central-1",
  "eu-west-1",
  "eu-west-2",
  "eu-south-1",
  "eu-west-3",
  "eu-south-2",
  "eu-north-1",
  "eu-central-2",
  "il-central-1",
  "me-south-1",
  "me-central-1",
  "sa-east-1",
  "us-gov-east-1",
  "us-gov-west-1",
];

// All regions with VM support in Azure
// https://azure.microsoft.com/en-us/explore/global-infrastructure/products-by-region/table
export const VALID_AZURE_VM_REGIONS = [
  // United States
  "eastus",
  "eastus2",
  "southcentralus",
  "westus2",
  "westus3",
  "centralus",
  "northcentralus",
  "westus",
  "westcentralus",
  "eastusstg",
  "southcentralusstg",

  // Canada
  "canadacentral",
  "canadaeast",

  // Europe
  "northeurope",
  "westeurope",
  "uksouth",
  "ukwest",
  "francecentral",
  "francesouth",
  "germanywestcentral",
  "germanynorth",
  "switzerlandnorth",
  "switzerlandwest",
  "italynorth",
  "norwayeast",
  "norwaywest",
  "polandcentral",
  "spaincentral",
  "swedencentral",

  // Asia Pacific
  "southeastasia",
  "eastasia",
  "australiaeast",
  "australiasoutheast",
  "australiacentral",
  "australiacentral2",
  "japaneast",
  "japanwest",
  "koreacentral",
  "koreasouth",
  "centralindia",
  "southindia",
  "westindia",
  "jioindiacentral",
  "jioindiawest",

  // Middle East
  "uaenorth",
  "uaecentral",
  "israelcentral",
  "qatarcentral",

  // Africa
  "southafricanorth",
  "southafricawest",

  // South America
  "brazilsouth",
  "brazilsoutheast",
  "brazilus",

  // Mexico
  "mexicocentral",
];
